import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '@proget-shared/dialog';
import { DialogTemplateModule } from '@proget-shared/dialog/dialog-template';
import { TranslateModule } from '@proget-shared/translate';
import { ProgressBarModule } from '@proget-shared/ui/progress-bar';

import { WorkProgressDialogComponent } from './component/work-progress-dialog/work-progress-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    DialogModule,
    DialogTemplateModule,
    TranslateModule.forChild(),
    ProgressBarModule,
  ],
  declarations: [WorkProgressDialogComponent],
  exports: [ProgressBarModule],
})
export class BatchWorkModule {}
